module.exports = __webpack_public_path__ + "img/9.bd57ac44.png";